import * as yup from 'yup';
export const ConfigEntrySchema = yup
    .object({
    enabled: yup.boolean(),
    botToken: yup.string().optional(),
    webhooks: yup
        .array()
        .of(yup.object({
        url: yup.string().url().optional(),
        channel: yup.string().optional(),
        token: yup.string().optional(),
        environments: yup.array().of(yup.string()).optional(),
        projects: yup.array().of(yup.string()).optional(),
    }))
        .optional(),
    resolvedNotificationsEnabled: yup.boolean().optional(),
})
    .default({ enabled: false });
export const NotificationConfigSchema = yup
    .object({
    slack: ConfigEntrySchema,
    pagerduty: ConfigEntrySchema,
})
    .default({ slack: { enabled: false }, pagerduty: { enabled: false } });
//# sourceMappingURL=schemas.js.map